import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, Target, Shapes, Coins } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

const StatisticsCards = ({ websitesAnalyzed, matchesFound, customTypes, remainingCredits, isLoading }) => {
    const stats = [
        {
            title: 'Websites analyzed',
            value: websitesAnalyzed.toLocaleString(),
            icon: Activity,
            description: `${websitesAnalyzed} websites analyzed in last analysis`
        },
        {
            title: 'Matches',
            value: matchesFound.toLocaleString(),
            icon: Target,
            description: `${matchesFound} matches found in last analysis`
        },
        {
            title: 'Custom Types',
            value: customTypes.toLocaleString(),
            icon: Shapes,
            description: 'Your active custom analysis types'
        },
        {
            title: 'Remaining Credits',
            value: remainingCredits.toLocaleString(),
            icon: Coins,
            description: 'Available credits for analyses'
        },
    ];

    return (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat, index) => (
                <TooltipProvider key={index}>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Card className="hover:bg-accent/5 transition-colors">
                                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                    <CardTitle className="text-sm font-medium">
                                        {isLoading ? (
                                            <Skeleton className="h-4 w-24" />
                                        ) : (
                                            stat.title
                                        )}
                                    </CardTitle>
                                    {isLoading ? (
                                        <Skeleton className="h-4 w-4 rounded" />
                                    ) : (
                                        <stat.icon className="h-4 w-4 text-muted-foreground" />
                                    )}
                                </CardHeader>
                                <CardContent>
                                    {isLoading ? (
                                        <Skeleton className="h-8 w-20" />
                                    ) : (
                                        <div className="text-2xl font-bold">
                                            {stat.value}
                                        </div>
                                    )}
                                </CardContent>
                            </Card>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{stat.description}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            ))}
        </div>
    );
};

export default StatisticsCards;